import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=1304e1c0&scoped=true"
import script from "./ticketInfo.vue?vue&type=script&lang=js"
export * from "./ticketInfo.vue?vue&type=script&lang=js"
import style0 from "./ticketInfo.vue?vue&type=style&index=0&id=1304e1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304e1c0",
  null
  
)

export default component.exports